import React, { ComponentProps, useState } from 'react';
import { Route, withRouter, RouteComponentProps } from 'react-router-dom';
import { weappSDK } from '@weapp/utils';


import { fomatParentPath } from '../../utils';
import { MQuickCreate } from '../../lib';

function QuickCreate(props: RouteComponentProps & ComponentProps<any>) {

  const [visible, setVisible] = useState(true);

  const onClose = () => {
    weappSDK.checkApi('closeWindow').then(() => {
      weappSDK.exec('closeWindow', {}).then(() => {
        
      }).catch((err: any) => {
        console.log("### js sdk error..." + err);
      })
    }).catch(() => {
      console.log("### js sdk check error...");
    })
    setVisible(false);
  }
  let parentPath: string = fomatParentPath(props);
  
  return (
    <Route weId={`${props.weId || ''}_pb8iga`} exact path={`${parentPath}/mobile/uk/quickCreate`}>
      {
        <MQuickCreate weId={`${props.weId || ''}_t8wf3t`} visible={visible} handleFastMenuVisible={onClose} />
      }
    </Route>
  )
}

export default withRouter(QuickCreate);